import {
    MDBBtn,
    MDBCard,
    MDBCardBody,
    MDBCol,
    MDBDatatable,
    MDBIcon,
    MDBInput,
    MDBModal,
    MDBModalBody,
    MDBModalContent,
    MDBModalDialog,
    MDBModalFooter,
    MDBModalHeader,
    MDBModalTitle,
    MDBRow,
    MDBSpinner,
    MDBTable, MDBTableBody, MDBTableHead, MDBTabs, MDBTabsContent, MDBTabsItem,
    MDBTabsLink, MDBTabsPane,
    MDBTextArea
} from "mdb-react-ui-kit";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import Body from "../components/body/BodyPage";
import MainLinks from "../components/navlinks/MainLinks";
import BillingContractSeatReport from "../components/editviews/billing/BillingContractSeatReport";
import BillingAccInfo from "../components/editviews/billing/BillingAccInfo";
import BillingStmtSummary from "../components/editviews/billing/BillingStmtSummary";
import BillingCircuitDetails from "../components/editviews/billing/BillingCircuitDetails";
import BillingSDWANDetails from "../components/editviews/billing/BillingSDWANDetails";
import { displayCancelAccount, getBiilingAccountInfoDetails } from "../apiclients/streamsapi_bridge";
import { useNavigate } from "react-router";
import { Controller, useForm } from "react-hook-form";
import { validatePhoneNumber } from "./popups/phonenumbers/AddRemoveNumbers";
import { getStreamsProductName } from "../apiclients/CommonUtils";
import TabIDConstant from "../apiclients/TabIDConstant";
function BillingAccountInfo(props) {
    const [selectVal, setSelectVal] = useState("africa");
    const [verticalActive, setVerticalActive] = useState("tab1");
    const streamsProductName = getStreamsProductName();

    const handleVerticalClick = (value) => {
        if (value === verticalActive) {
            return;
        }

        setVerticalActive(value);
    };

    const [basicActive1, setBasicActive1] = useState("tab5");
    const [basicActive2, setBasicActive2] = useState("tab7");
    // const [basicActive, setBasicActive] = useState("tab1");

    const handleBasicClick1 = (value) => {
        if (value === basicActive1) {
            return;
        }

        setBasicActive1(value);
    };
    const handleBasicClick2 = (value) => {
        if (value === basicActive2) {
            return;
        }

        setBasicActive2(value);
    };
    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }

        setBasicActive(value);
    };
    const [basicModal, setBasicModal] = useState(false);
    const basicData = {
        columns: [
            "Phone Name",
            "User",
            "Extension",
            "Model",
            "Mac Address",
            "Configuration",
            "Online",
        ],
        rows: [
            [
                "Poly VVX 601",
                "Tiger ",
                "5000",
                "Nixon",
                "541 863 9874",
                "ULM Streams",
                "1234567890123456",
            ],
            [
                "Poly VVX 601",
                "Tiger ",
                "5000",
                "Nixon",
                "541 863 9874",
                "ULM Streams",
                "1234567890123456",
            ],
            [
                "Poly VVX 601",
                "Tiger ",
                "5000",
                "Nixon",
                "541 863 9874",
                "ULM Streams",
                "1234567890123456",
            ],
        ],
    };

    const basicData1 = {
        columns: [
            "Name",
            "Address",
            "Primary Contact",
            "Primary Number",
            "IP Phone Device",
            "Remove",
        ],
        rows: [
            [
                "Florida",
                "1385 Doss Avenue ",
                "Nick Leyelander",
                "541 863 9874",
                "4",
                "X",
            ],
            [
                "Florida",
                "1385 Doss Avenue ",
                "Nick Leyelander",
                "541 863 9874",
                "4",
                "X",
            ],
            [
                "Florida",
                "1385 Doss Avenue ",
                "Nick Leyelander",
                "541 863 9874",
                "4",
                "X",
            ],
            [
                "Florida",
                "1385 Doss Avenue ",
                "Nick Leyelander",
                "541 863 9874",
                "4",
                "X",
            ],
        ],
    };

    const basicData3 = {
        columns: [
            "Name",
            "Address",
            "911 Verified",
            "Primary Contact",
            "Primary Number",
            "Users",
            "IP Phone Device",
            "Remove",
        ],
        rows: [
            [
                "Florida",
                "1385 Doss Avenue ",
                "Yes",
                "Nick Leyelander",
                "541 863 9874",
                "6",
                "4",
                "X",
            ],
            [
                "Florida",
                "1385 Doss Avenue ",
                "Yes",
                "Nick Leyelander",
                "541 863 9874",
                "6",
                "4",
                "X",
            ],
            [
                "Florida",
                "1385 Doss Avenue ",
                "Yes",
                "Nick Leyelander",
                "541 863 9874",
                "6",
                "4",
                "X",
            ],
            [
                "Florida",
                "1385 Doss Avenue ",
                "Yes",
                "Nick Leyelander",
                "541 863 9874",
                "6",
                "4",
                "X",
            ],
        ],
    };

    const basicData4 = {
        columns: ["Paging Group", "Group ID", "Remove"],
        rows: [
            ["Poly VVX 601", "1", "X"],
            ["Poly VVX 601", "2", "X"],
            ["Poly VVX 601", "3", "X"],
            ["Poly VVX 601", "4", "X"],
        ],
    };
    const basicData5 = {};
    const toggleShow = () => setBasicModal(!basicModal);

    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();

    const [basicActive, setBasicActive] = useState('tab1');
    const [fullscreenXlModal, setFullscreenXlModal] = useState(false);

    const toggleOpen = () => {
        setFullscreenXlModal(!fullscreenXlModal)
        console.log("toggleOpen nonInvasive", fullscreenXlModal);
    };
    const navigate = useNavigate();
    const [isloading, setIsloading] = useState(false);
    const [accInfo, setaccInfo] = useState({});
    const [contractSeatInfo, setcontractSeatInfo] = useState([]);
    const [circuitDetails, setcircuitDetails] = useState([]);
    const [sdWan, setsdWan] = useState([]);
    const [billingstmtsummary, setbillingstmtsummary] = useState([]);
    const [physicalAddress, setphysicalAddress] = useState({});
    const [mailingAddress, setmailingAddress] = useState({});
    const [principleOfOrg, setprincipleOfOrg] = useState([]);
    const [majorityOwner, setmajorityOwner] = useState([]);
    const [complianceAdminstrator, setcomplianceAdminstrator] = useState([]);
    const [seatSummary, setseatSummary] = useState([]);
    const [isContractAccount, setisContractAccount] = useState(0);
    const [accountSeatSummary, setaccountSeatSummary] = useState({});
    const [showCancelButton, setshowCancelButton] = useState(false);
    const [companyName, setcompanyName] = useState("");
    const [userName, setuserName] = useState("");
    const isWholesaleAcc = JSON.parse(sessionStorage.getItem("admin_session"))?.isWholesaleAcc ?? false;
    const { register, handleSubmit, control, formState: { errors, dirtyFields, isDirty }, setValue, watch, reset, clearErrors } = useForm({
        defaultValues: {
            account_name: "",
            account_administrator_Email: "",
            account_administrator_phone: "",
            hosted_pbx_sol: false,
            customer_pbx_sol: false,
            project_postponed: false,
            not_offer_features: false,
            streams_costs: false,
            other_reasons: false,
            additional_comments: "",
            retain_ph_numbers: true,
            list_of_ph_numbers: "",
            account_administrator_name: "",
            account_administrator_initials: "",
        }
    });

    useEffect(() => {

        getBillingAccountInfo();
    }, []);
    async function getBillingAccountInfo() {
        setIsloading(true);
        const response = await getBiilingAccountInfoDetails(
            JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            TabIDConstant.BILL_ACC_INFO_SUBLINK
        );
        setIsloading(false);
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const rawData = await response.json();
        if (!rawData) {
            window.alert(`info with id  not found`);
            navigate("/");
        }
        console.log("response data is :::::::::: " + JSON.stringify(rawData));
        setaccInfo(rawData?.Account_information ?? {});
        setcontractSeatInfo(rawData?.Contract_seats_report ?? []);
        setcircuitDetails(rawData?.Circuit_Details ?? []);
        setsdWan(rawData?.SD_WAN_Details ?? []);
        setbillingstmtsummary(rawData?.SD_Billing_Statement_Summary ?? []);
        setphysicalAddress(rawData?.Physical_Address?.length > 0 ? rawData?.Physical_Address[0] : {});
        setmailingAddress(rawData?.Mailing_Address?.length > 0 ? rawData?.Mailing_Address[0] : {});
        setprincipleOfOrg(rawData?.Key_Principal_of_the_Organization ?? []);
        setmajorityOwner(rawData?.Majority_Owners ?? []);
        setcomplianceAdminstrator(rawData?.Compliance_Administrator ?? []);
        setshowCancelButton(rawData?.showCancelAccButton !== undefined ? rawData?.showCancelAccButton : false);
        // setseatSummary(rawData?.seat_summary ?? []);
        // setisContractAccount(rawData.is_contract_account !== undefined ? rawData.is_contract_account : 0);
        // setaccountSeatSummary(rawData?.accountSeatsInfo ?? {});


    }

    const showCancelAccount = (e) => {
        e.preventDefault();
        displayCancelAPIRequest();

    }

    const displayCancelAPIRequest = async () => {
        setIsloading(true);
        const update = {
            reqid: 144,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            flag: 1
        }
        const response = await displayCancelAccount(update);
        setIsloading(false);

        // alert("verifying .....");
        if (!response.json) {
            const message = `An error has occured: ${response.statusText}`;
            return;
        }
        const rawData = await response.json();
        if (!rawData) {
            window.alert(`info with id  not found`);
            navigate("/");
        }

        reset((prev) => ({
            ...prev,
            account_name: rawData?.account_name ?? "",
            account_administrator_Email: rawData?.account_administrator_Email ?? "",
            account_administrator_name: rawData?.account_administrator_name ?? "",
        }));
        toggleOpen();
    }

    // console.log("errors :::::::: " + JSON.stringify(errors));

    const onSubmit = async (data) => {
        const update = {
            reqid: 144,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            flag: 0,
            ...data,

        }
        setIsloading(true);
        console.log("request for cancel account ::::::::: " + JSON.stringify(update));
        const response = await displayCancelAccount(update);
        setIsloading(false);
        const rawData = await response.json();
        if (rawData.status === "success") {
            setcompanyName(data?.account_name ?? "");
            setuserName(data?.account_administrator_name ?? "");

            setIsSubmitted(true);
        }



    }

    const [isSubmitted, setIsSubmitted] = useState(false);


    return (
        <React.Fragment>
            <>
                <MainLinks active={5} />
                <Body
                    tablinks={5}
                    sublink={222}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header p-3 px-0 d-flex justify-content-between w-100">
                                        <h5 className="mb-0 ">{t("Billing")}</h5>
                                        {showCancelButton && (
                                            <MDBBtn onClick={(e) => showCancelAccount(e)}>Cancel Account</MDBBtn>
                                        )}
                                    </div>

                                    <MDBTabs className='mb-3'>
                                        <MDBTabsItem>
                                            <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                Account Information
                                            </MDBTabsLink>
                                        </MDBTabsItem>

                                        {contractSeatInfo && contractSeatInfo.length > 0 && (

                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    {isContractAccount === 1 ? 'Contract Seats Report' : 'Seats Report'}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        )}
                                        {!isWholesaleAcc && billingstmtsummary && billingstmtsummary.length > 0 && (
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab3')} active={basicActive === 'tab3'}>
                                                    Billing Statement Summary
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        )}
                                        {circuitDetails && circuitDetails.length > 0 && (
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab4')} active={basicActive === 'tab4'}>
                                                    Circuit Details
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        )}
                                        {sdWan && sdWan.length > 0 && (
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab5')} active={basicActive === 'tab5'}>
                                                    SD-WAN Details
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        )}
                                    </MDBTabs>
                                    <MDBTabsContent>
                                        <MDBTabsPane open={basicActive === 'tab1'}>
                                            <BillingAccInfo
                                                accInfo={accInfo}
                                                physicalAddress={physicalAddress}
                                                mailingAddress={mailingAddress}
                                                principleOfOrg={principleOfOrg}
                                                majorityOwner={majorityOwner}
                                                complianceAdminstrator={complianceAdminstrator}
                                                setIsloading={setIsloading}
                                                reloadBillingData={getBillingAccountInfo}

                                            />
                                        </MDBTabsPane>
                                        <MDBTabsPane open={basicActive === 'tab2'}>
                                            <BillingContractSeatReport
                                                contractSeatInfo={contractSeatInfo}
                                                seatSummary={seatSummary}
                                                isContractAccount={isContractAccount}
                                                accountSeatSummary={accountSeatSummary}
                                            />
                                        </MDBTabsPane>
                                        {!isWholesaleAcc &&
                                            <MDBTabsPane open={basicActive === 'tab3'}>
                                                <BillingStmtSummary
                                                    billingstmtsummary={billingstmtsummary}
                                                />
                                            </MDBTabsPane>
                                        }
                                        <MDBTabsPane open={basicActive === 'tab4'}>
                                            <BillingCircuitDetails
                                                circuitDetails={circuitDetails} />
                                        </MDBTabsPane>
                                        <MDBTabsPane open={basicActive === 'tab5'}>
                                            <BillingSDWANDetails
                                                sdWan={sdWan}
                                            />
                                        </MDBTabsPane>
                                    </MDBTabsContent>
                                </div>
                            </section>
                            <MDBModal open={fullscreenXlModal} onClose={() => setFullscreenXlModal(false)} nonInvasive={false}>
                                <MDBModalDialog size={isSubmitted ? "lg" : "xl"}>
                                    <MDBModalContent>
                                        <MDBModalHeader className="d-flex justify-content-between align-items-center">
                                            <MDBModalTitle>
                                                {isSubmitted ?
                                                    <>
                                                        Account cancellation request
                                                    </> : <>
                                                        {streamsProductName} Account Cancellation Form
                                                    </>
                                                }
                                            </MDBModalTitle>
                                            <div className="d-flex align-items-center">
                                                <strong className="me-5"><MDBIcon fas icon="phone-square" color="primary" className="me-3" />REACH US AT : (800) 805-0558 or +1 (408) 702-2200</strong>
                                                {!isSubmitted && (
                                                    <MDBBtn type='button' className='btn-close' color='none' onClick={(e) => { reset(); toggleOpen(); }}></MDBBtn>
                                                )}
                                            </div>
                                        </MDBModalHeader>

                                        {!isSubmitted ? (
                                            <MDBModalBody className="vh-100">
                                                <p className="mb-2">Thank you for using {streamsProductName}. Were sorry to see you go. Your account will be closed once you submit this form. You will receive an email confirming that it has been terminated. Please help us improve our service by answering the questions below.</p>
                                                <p className="mb-2">Please note: in the "Number Porting" section below, please be sure to carefully list the phone numbers you wish to keep from your {streamsProductName} account, if any. Please be aware: if you do not specifically list which numbers you wish to retain and port to your new service provider, we will make any of your {streamsProductName} numbers available to other {streamsProductName} accounts in the future. You will have no claim to these numbers in the future.
                                                </p>
                                                <div className="border p-3 mb-3">
                                                    <h5>Account Information</h5>
                                                    <section className="px-3 w-100 mob-w-100 mb-3">
                                                        <div className="w-100">
                                                            <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                                <label className="w-75">Account Name <span className="red">*</span></label>
                                                                <div className="w-300px" ><MDBInput className="w-100" {...register("account_name")} disabled />
                                                                    {errors.account_name && (
                                                                        <p className="text-danger">{errors.account_name.message}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                                <label className="w-75">Account Administrator E-mail <span className="red">*</span></label>
                                                                <div className="w-300px" >
                                                                    <MDBInput className="w-100" {...register("account_administrator_Email", {
                                                                        required: "Email Address is required",
                                                                        setValueAs:(v)=>v?.trim(),
                                                                        pattern: {
                                                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                            message: "Invalid email address",
                                                                        },
                                                                    })} disabled />
                                                                    {errors.account_administrator_Email && (
                                                                        <p className="text-danger">{errors.account_administrator_Email.message}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                                <div>
                                                                    <label className="w-100">Account Administrator Phone  <span className="red">*</span></label>
                                                                    <small>(please use a non-{streamsProductName} number where {streamsProductName} Customer Service can reach you)</small>
                                                                </div>
                                                                <div className="w-300px" ><MDBInput className="w-100" {...register("account_administrator_phone", { required: "Account Administrator Phone should not be empty", validate: validatePhoneNumber, })} />
                                                                    {errors.account_administrator_phone && (
                                                                        <p className="text-danger">{errors.account_administrator_phone.message}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                    <h5>Please tell us why you chose to end your {streamsProductName} subscription</h5>
                                                    {errors.account_administrator_Email && (
                                                        <p className="text-danger">{errors.account_administrator_Email.message}</p>
                                                    )}
                                                    <section className="px-3 w-100 mob-w-100 mb-3">
                                                        <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                            <label className="w-75">I have selected another hosted PBX solution. </label>
                                                            <div><div className="phoneselect">
                                                                <label className="switch">
                                                                    <input className="form-control" type="checkbox" {...register("hosted_pbx_sol")} />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                            <label className="w-75">I have selected another customer premise-based PBX solution.  </label>
                                                            <div><div className="phoneselect">
                                                                <label className="switch">
                                                                    <input className="form-control" type="checkbox" {...register("customer_pbx_sol")} />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                            <label className="w-75">Our project/plans have been postponed. </label>
                                                            <div><div className="phoneselect">
                                                                <label className="switch">
                                                                    <input className="form-control" type="checkbox" {...register("project_postponed")} />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                            <label className="w-75">{streamsProductName} does not offer the features I am looking for. </label>
                                                            <div><div className="phoneselect">
                                                                <label className="switch">
                                                                    <input className="form-control" type="checkbox" {...register("not_offer_features")} />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                            <label className="w-75">{streamsProductName} costs more than I was prepared to spend. </label>
                                                            <div><div className="phoneselect">
                                                                <label className="switch">
                                                                    <input className="form-control" type="checkbox" {...register("streams_costs")} />
                                                                    <span className="slider round"></span>
                                                                </label>
                                                            </div>
                                                            </div>
                                                        </div>
                                                        <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                            <label className="w-75">Other reasons (specify in comments area below) </label>
                                                            <div>
                                                                <div className="phoneselect">
                                                                    <label className="switch">
                                                                        <input className="form-control" type="checkbox" checked={watch("other_reasons")}
                                                                            onChange={(e) => {
                                                                                setValue("other_reasons", e.target.checked, { shouldDirty: true });
                                                                                clearErrors("additional_comments");
                                                                            }}
                                                                        />
                                                                        <span className="slider round"></span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                            <label className="w-75">Additional Comments </label>
                                                            <div className="w-300px" >
                                                                <Controller
                                                                    name="additional_comments"
                                                                    control={control}
                                                                    rules={{
                                                                        validate: (value) => {
                                                                            if (watch("other_reasons") && !value) {
                                                                                return "Additional Comments is required";
                                                                            }
                                                                            return true;
                                                                        }
                                                                    }}

                                                                    render={({ field }) => (
                                                                        <MDBTextArea className="w-100" rows={4}
                                                                            value={watch("additional_comments")}
                                                                            maxLength={1000}
                                                                            onChange={(e) => {
                                                                                clearErrors("additional_comments");
                                                                                setValue("additional_comments", e.target.value, { shouldDirty: true });
                                                                            }
                                                                            } />
                                                                    )}
                                                                />
                                                                {errors?.additional_comments && (
                                                                    <p className="text-danger">{errors?.additional_comments?.message}</p>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </section>

                                                    <h5>Number Porting</h5>
                                                    <section className="px-3 w-100 mob-w-100 mb-3">
                                                        <div className="w-100">
                                                            <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                                <label className="w-75">Would you like to retain any of the phone numbers you purchased from {streamsProductName}?</label>
                                                                <div className="w-300px" ><div>
                                                                    <div className="phoneselect">
                                                                        <label className="switch">
                                                                            <input className="form-control" type="checkbox" checked={watch("retain_ph_numbers")}
                                                                                onChange={(e) => {
                                                                                    setValue("retain_ph_numbers", e.target.checked, { shouldDirty: true });
                                                                                    clearErrors("list_of_ph_numbers");
                                                                                }}
                                                                            />
                                                                            <span className="slider round"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            </div>

                                                            <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                                <label className="w-75">If yes, please list these numbers below</label>
                                                                <div className="w-300px" >
                                                                    <Controller
                                                                        name="list_of_ph_numbers"
                                                                        control={control}
                                                                        rules={{
                                                                            validate: (value) => {
                                                                                if (watch("retain_ph_numbers") && !value) {
                                                                                    return "Please specify Ported Numbers.";
                                                                                }
                                                                                return true;
                                                                            }
                                                                        }}


                                                                        render={({ field }) => (
                                                                            <MDBTextArea className="w-100" rows={4}
                                                                                value={watch("list_of_ph_numbers")}
                                                                                onChange={(e) => {
                                                                                    clearErrors("list_of_ph_numbers");
                                                                                    setValue("list_of_ph_numbers", e.target.value, { shouldDirty: true });
                                                                                }
                                                                                }
                                                                            />
                                                                        )}
                                                                    />
                                                                    {errors?.list_of_ph_numbers && (
                                                                        <p className="text-danger">{errors?.list_of_ph_numbers?.message}</p>
                                                                    )}

                                                                </div>
                                                            </div>
                                                            <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                                <label className="w-75">Name of the Account Administrator  <span className="red">*</span></label>
                                                                <div className="w-300px" ><MDBInput className="w-100" {...register("account_administrator_name", { required: "Name of the Account Administrator should not be empty" })} />
                                                                    {errors.account_administrator_name && (
                                                                        <p className="text-danger">{errors.account_administrator_name.message}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                            <div className="py-1 w-70 d-flex align-items-center justify-content-between" >
                                                                <label className="w-75">Initials of Account Administrator </label>
                                                                <div className="w-300px" ><MDBInput className="w-100" {...register("account_administrator_initials")} />
                                                                    {errors.account_administrator_initials && (
                                                                        <p className="text-danger">{errors.account_administrator_initials.message}</p>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </section>
                                                </div>
                                                <p className="mb-2">Entering your full initials verifies your identity and confirms that you wish to terminate your {streamsProductName} Main Account.</p>
                                                <p className="mb-2">In case you change your mind, our systems will maintain information relating to your account for one month from the day that the account is closed. After this one month period, all information relating to your account will be purged from our systems.
                                                </p>

                                            </MDBModalBody>
                                        ) : <>
                                            <MDBModalBody>

                                                <MDBCard className="shadow-0 p-0">
                                                    <MDBCardBody>

                                                        <p className="mb-2"><strong>Dear {userName}</strong></p>
                                                        <p>
                                                            Thank you for your association with <strong>{companyName}</strong>. We are sorry to know that you have opted to cancel your account. Your cancellation request is under process.
                                                        </p>
                                                        <p>
                                                            Meanwhile if you have any questions or suggestions, please feel free to contact us at: <strong>(800) 805-0558</strong> or mail to <strong>billing@panterranetworks.com</strong>
                                                        </p>
                                                        {/* <p className="mt-2">Go to <a onClick={() => window.location.href = "/login"}>Login</a> page.</p> */}
                                                    </MDBCardBody>
                                                </MDBCard>
                                            </MDBModalBody>
                                            <MDBModalFooter>
                                                <MDBBtn onClick={(e) => {
                                                    e.preventDefault();
                                                    getBillingAccountInfo();
                                                    toggleOpen();
                                                }}>OK</MDBBtn>
                                            </MDBModalFooter>
                                        </>}
                                        {!isSubmitted &&
                                            <MDBModalFooter>
                                                <MDBBtn type='button' color='secondary' onClick={(e) => { reset(); toggleOpen(); }}>
                                                    Close
                                                </MDBBtn>
                                                <MDBBtn onClick={(e) => {
                                                    e.preventDefault();
                                                    handleSubmit(onSubmit)();
                                                }}>Submit</MDBBtn>
                                            </MDBModalFooter>
                                        }
                                    </MDBModalContent>
                                </MDBModalDialog>
                            </MDBModal>
                        </>
                    }


                />
                {/* <Footer /> */}
                <Tooltip anchorSelect=".AddToolTip" place="top" className="exampleTooltip">
                    View
                </Tooltip>
                <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                    Download
                </Tooltip>
                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}


            </>
        </React.Fragment>
    );
}

export default BillingAccountInfo;
